<template>
  <section class="box-layout" style="position: relative">
    <div class="manage-plan__content">
      <header class="content__header">
        <h2>{{ $t('userInfo.lnb.managePlan') }}</h2>
        <div class="button--wrap"></div>
      </header>
      <template v-if="isLoading">
        <ui-loading-circle :class="{ie: browser.isIE}"></ui-loading-circle>
      </template>
      <template v-else>
        <div class="content__body" ref="scrollContent">
          <div class="content__top">
            <content-box class="content__plan-in-use" :width="'65%'" :height="'240px'">
              <p class="content__title">
                {{ $t('common.planInUse') }}
<!--                <span v-if="planData.useCoupon" class="coupon-text">{{ $t('common.coupon') }}</span>-->
                <span v-if="planData.useCoupon" class="coupon-text">{{ $t('common.coupon') }}</span>
              </p>
              <div class="content__plan-name">
                <strong class="plan-name" :class="{ using: planData.hasPlan }">
                  <template v-if="planData.hasPlan">
                    {{ planData.planName }}
                    <span class="payment-type" v-if="planData.useCoupon">
                      <i class="icon icon--is-coupon"></i>
                      <ui-tooltip arrowBottom arrowCenter>{{ $t('userInfo.managePlan.default.coupon') }}</ui-tooltip>
                    </span>
                    <span class="payment-type" v-if="planData.isCardPlan">
                      <i class="icon icon--is-card"></i>
                      <ui-tooltip arrowBottom arrowCenter>{{ $t('userInfo.managePlan.default.card') }}{{ $t('userInfo.managePlan.default.subscription') }}</ui-tooltip>
                    </span>
                    <span class="payment-type" v-if="planData.isWireTransferPlan">
                      <i class="icon icon--is-wire-transfer"></i>
                      <ui-tooltip arrowBottom arrowCenter>{{ $t('userInfo.managePlan.default.wire') }}</ui-tooltip>
                    </span>
                  </template>
                  <template v-else>{{ $t('common.noPlanInUse') }}</template>
                </strong>
              </div>
              <div class="content_outer">
                <div class="content">
                  <div class="plan-period">
                    <p class="label">{{ $t('common.subscriptionTerms') }}</p>
                    <p v-if="planData.hasPlan" class="value">
                      <time datetime="">{{ planData.startDate | dateFormatTimezone(userData.timezoneName) }}</time> ~
                      <time datetime="">{{ planData.endDate | dateFormatTimezone(userData.timezoneName) }}</time>
                    </p>
                    <p v-else class="value">-</p>
                  </div>
                  <div class="subscribe--wrap">
                    <template v-if="!planData.hasPlan">
                      <template v-if="planData.next">
                        <template v-if="planData.next.isCardPlan || planData.next.isWireTransferPlan">
                          <template v-if="planData.next.isCardPlan">
                            <p class="label">{{ planData.next.planName }}{{ $t('common.cardPlan') }}</p>
                          </template>
                          <template v-else-if="planData.next.isWireTransferPlan">
                            <p class="label">{{ planData.next.planName }}{{ $t('common.wireTransaction') }}</p>
                          </template>
                          <template v-else>
                            <p class="label">{{ planData.next.planName }}</p>
                          </template>
                          <p class="value">
                            {{ $t('userInfo.managePlan.default.subscribe.value.nextPlanStartDate', {
                              nextStartDate: getLocaleDateStr(planData.next.startDate)
                            }) }}
                          </p>
                        </template>
                      </template>
                      <template v-else>
                        <div class="start-subscribe">
                          <p class="label">{{ $t('userInfo.managePlan.default.subscribe.toStart') }}</p>
                          <button @click="onChangePlan">
                            {{ $t('common.subscribeYourPlan') }}
                            <i class="icon icon--next-red-size16"></i>
                          </button>
                        </div>
                      </template>
                    </template>
                    <template v-else-if="planData.isTrial">
                      <div class="start-subscribe">
                        <p class="label">{{ $t('userInfo.managePlan.default.subscribe.toContinue') }}</p>
                        <button @click="onChangePlan">
                          {{ $t('common.subscribeYourPlan') }}
                          <i class="icon icon--next-red-size16"></i>
                        </button>
                      </div>
                    </template>
                    <template v-else-if="planData.isUnpaid">
                      <ui-button :primary="true" :size="'large'" @click="isShowCancelSubscription = true">
                        {{ $t('common.cancelSubscription') }}
                      </ui-button>
                    </template>
                    <template v-else-if="planData.isCardPlan">

                      <template v-if="planData.next">
                        <template v-if="planData.next.isCardPlan">
                          <template v-if="planData.next.isDowngrade">
                            <div class="start-subscribe">
                              <p class="label">
                                {{ $t('userInfo.managePlan.default.subscribe.downgrade', {
                                  nextPlan: planData.next.planName,
                                  nextStartDate: getLocaleDateStr(planData.next.startDate)
                                }) }}
                                <br>
                                <button @click="onWithdrawPlanCancellation(true)">
                                  {{ $t('common.cancelPlanChange') }}
                                  <i class="icon icon--next-red-size16"></i>
                                </button>
                              </p>
                            </div>
                          </template>
                          <template v-else-if="planData.next.isUpgrade">
                            <!-- abnormal case -->
                          </template>
                          <template v-else>
                            <ui-button :primary="true" :size="'large'" @click="isShowCancelSubscription = true">
                              {{ $t('common.cancelSubscription') }}
                            </ui-button>
                          </template>
                        </template>
                        <template v-else-if="planData.next.isWireTransferPlan">
                          <p class="label">{{ planData.next.planName }}{{ $t('common.wireTransaction') }}</p>
                          <p class="value">
                            {{ $t('userInfo.managePlan.default.subscribe.value.nextPlanStartDate', {
                              nextStartDate: getLocaleDateStr(planData.next.startDate)
                            }) }}
                          </p>
                        </template>
                        <template v-else>
                          <p class="label">{{ planData.next.planName }}</p>
                          <p class="value">
                            {{ $t('userInfo.managePlan.default.subscribe.value.nextPlanStartDate', {
                            nextStartDate: getLocaleDateStr(planData.next.startDate)
                          }) }}
                          </p>
                        </template>
                      </template>
                      <template v-else>
                        <p class="label">{{ $t('userInfo.managePlan.default.subscribe.label.nextPlanExpire') }}</p>
                        <p class="value">
                          {{ computedPlanEndDate | localeDate }}
                        </p>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="planData.next">
<!--                        <template v-if="planData.next.isCardPlan || planData.next.isWireTransferPlan">-->
                        <template v-if="planData.next.isCardPlan">
                          <template v-if="planData.next.isSameAsCurrent || planData.next.isDowngrade">
                            <div class="start-subscribe">
                              <p class="label">
                                {{ $t('userInfo.managePlan.default.subscribe.downgrade', {
                                nextPlan: planData.next.planName,
                                nextStartDate: getLocaleDateStr(planData.next.startDate)
                              }) }}
                                <br>
                                <button @click="onCancelSubscription(true)">
                                  {{ $t('common.cancelSubscription') }}
                                  <i class="icon icon--next-red-size16"></i>
                                </button>
                              </p>
                            </div>
                          </template>
                          <template v-else>
                            <div class="start-subscribe">
                              <p class="label">
                                {{ $t('userInfo.managePlan.default.subscribe.downgrade', {
                                nextPlan: planData.next.planName,
                                nextStartDate: getLocaleDateStr(planData.next.startDate)
                              }) }}
                                <br>
                                <button @click="onWithdrawPlanCancellation(true)">
                                  {{ $t('common.cancelPlanChange') }}
                                  <i class="icon icon--next-red-size16"></i>
                                </button>
                              </p>
                            </div>
                          </template>
                        </template>
                        <template v-else-if="planData.next.isWireTransferPlan">
                          <p class="label">{{ planData.next.planName }}{{ $t('common.wireTransaction') }}</p>
                          <p class="value">
                            {{ $t('userInfo.managePlan.default.subscribe.value.nextPlanStartDate', {
                            nextStartDate: getLocaleDateStr(planData.next.startDate)
                          }) }}
                          </p>
                        </template>
                        <template v-else>
                          <p class="label">{{ planData.next.planName }}</p>
                          <p class="value">
                            {{ $t('userInfo.managePlan.default.subscribe.value.nextPlanStartDate', {
                            nextStartDate: getLocaleDateStr(planData.next.startDate)
                          }) }}
                          </p>
                        </template>
<!--                        </template>-->
                      </template>
                      <template v-else>
                        <p class="label">{{ $t('userInfo.managePlan.default.subscribe.label.nextPlanExpire') }}</p>
                        <p class="value">
                          {{ planData.endDate | localeDate }}
                        </p>
                      </template>
                    </template>
<!--                    <template v-else>-->
<!--&lt;!&ndash;                      <div>abnormal case</div>&ndash;&gt;-->
<!--&lt;!&ndash;                      <div>{{ planData }}</div>&ndash;&gt;-->
<!--                    </template>-->
                  </div>
                </div>
              </div>
            </content-box>
            <content-box class="content__monthly-pv" :width="'35%'" :height="'240px'">
              <p class="content__title">{{ $t('common.monthlyPv') }}</p>
              <div class="content">
                <div class="battery--wrap">
                  <battery-indicator isLargeSize/>
                  <span class="value__pv">
                  <template v-if="planData.hasPlan">{{ pvPercentage }}%</template>
                  <template v-else>- %</template>
                </span>
                </div>
                <p class="remain-pv">
                  <template v-if="planData.hasPlan">
                    <strong>{{ userData.remainPv | thousand }} PV</strong>/ {{ userData.pvLimit | thousand }} PV
                  </template>
                  <template v-else>
                    <strong>- PV</strong>/ - PV
                  </template>
                </p>
                <div class="plan-period">
                  <p v-if="planData.monthlyStartDate && planData.monthlyEndDate">
                    <time datetime="">{{ planData.monthlyStartDate | dateFormatTimezone(userData.timezoneName) }}</time> ~
                    <time datetime="">{{ planData.monthlyEndDate | dateFormatTimezone(userData.timezoneName) }}</time>
                  </p>
                  <div v-else class="plan-period">-</div>
                </div>
                <div class="button--wrap">
                  <ui-button primary4
                             :disabled="!canChargePv"
                             :iconName="'icon--pv-plug'"
                             @click="onChargePv()">
                    {{ $t('common.chargePv') }}
                  </ui-button>
                </div>
              </div>
            </content-box>
          </div>

          <div class="content__middle">
            <div class="chart-type">
              <button :class="{ on: this.currentChart === 'plan' }"
                      @click="onSelectChartType('plan')">
                {{ $t('userInfo.managePlan.default.planChart') }}
              </button>
              <button :class="{ on: this.currentChart === 'pv' }"
                      @click="onSelectChartType('pv')">
                {{ $t('userInfo.managePlan.default.pvChart') }}
              </button>
            </div>

            <plan-chart v-if="this.currentChart === 'plan'" />

            <remain-pv-chart v-if="this.currentChart === 'pv'"
              :startDate="planData.startDate" />
          </div>
          <back-to-top refName="scrollContent"/>
        </div>
      </template>
      <dimmed v-if="dialogData">
        <plan-status-dialog
          :dialogData="dialogData"
          @onConfirm="onPlanStatusDialogConfirm"/>
      </dimmed>
      <dimmed v-if="useDimmed && !isCardRegistering">
        <template>
          <plan-subscription
            v-if="isShowPlanSubscription"
            :planData="planData"
            :userData="userData"
            @onNextPlan="onNextPlan"
            @onPlanNumberChange="onPlanNumberChange"
            @closeLayer="isShowPlanSubscription = false" />
<!--          <change-plan-->
<!--            v-if="!isCardRegistering && newPlanData && newPlanData.planNumber > 0"-->
<!--            v-show="!downgradeMore"-->
<!--            :userData="userData"-->
<!--            :planData="planData"-->
<!--            :newPlanData="newPlanData"-->
<!--            :paymentType="paymentType"-->
<!--            @onPlanNumberChange="onPlanNumberChange"-->
<!--            @onPaymentTypeChange="paymentType = $event"-->
<!--            @onConfirm="onPlanChangeConfirm"-->
<!--            @closeLayer="newPlanData = null"/>-->
          <plan-steps
            v-if="!isCardRegistering && newPlanData && newPlanData.planNumber > 0 && !isPayments"
            v-show="!downgradeMore"
            :userData="userData"
            :planData="planData"
            :newPlanData="newPlanData"
            :paymentType="paymentType"
            :planType="planType"
            @onPlanNumberChange="onPlanNumberChange"
            @onPayments="onPayments"
            @onChangePlan="onChangePlan"
            @onPaymentTypeChange="paymentType = $event"
            @onConfirm="onPlanChangeConfirm"
            @closeLayer="newPlanData = null"/>
          <change-plan
            v-if="isPayments && newPlanData && newPlanData.planNumber > 0"
            :userData="userData"
            :planData="planData"
            :applyPlanData="applyPlanData"
            :newPlanData="newPlanData"
            :paymentType="paymentType"
            :selectPlan="selectPlan"
            @onPlanNumberChange="onPlanNumberChange"
            @onPaymentTypeChange="paymentType = $event"
            @onConfirm="onPlanChangeConfirm"
            @closeLayer="isPayments = false, newPlanData = null"/>
        </template>
        <charge-pv
          v-if="!isCardRegistering && chargingPv"
          :userData="userData"
          :planData="planData"
          :chargingPv="chargingPv"
          @onConfirm="onChargePvConfirm"
          @closeLayer="chargingPv = null"/>
        <cancel-subscription
          v-if="isShowCancelSubscription"
          :planData="planData"
          @onCloseLayer="isShowCancelSubscription = false"
          @onConfirm="onCancelSubscription"/>
        <confirm-my-page
          v-if="downgradeMore"
          :planData="planData"
          :downgradeMore.sync="downgradeMore"/>
        <confirm-coupon-user
          v-if="isShowConfirmCouponUser"
          @onConfirm="isShowPlanSubscription = true"
          @closeLayer="isShowConfirmCouponUser = false"/>
      </dimmed>
      <register-card v-if="registerData"
        :userData="userData"
        :registerData="registerData"
        @onRegisterSuccess="onRegisterSuccess"
        @onRegisterCanceled="onRegisterCanceled"
        @onRegisterFailed="onRegisterFailed"/>
      <dimmed v-if="stateApplyPlan">
        <div class="user-applied-plan">
          <div class="plan-title">{{ $t('plan.pricing.total') }}</div>
          <div class="plan-info-wrap">
            <div class="plan-name">{{ applyPlanData.planName }}</div>
            <div class="plan-pv-info">{{ applyPlanData.pvText }}</div>
          </div>
          <div class="plan-detail-wrap">
            <div class="plan-discount-info">
              <div class="info-list">
                <div class="info-item">
                  <div class="info-name">{{ $t('plan.pricing.planFee') }}</div>
                  <div class="info-value">{{ applyPlanData.originPrice | thousand }}{{ $t('plan.pricing.currencyUnit') }}</div>
                </div>
                <div class="info-item" v-if="planType === 'enterprise'">
                  <div>{{ $t('plan.pricing.basicDiscount') }}</div>
                  <div class="info-value">
                    {{ $t('plan.pricing.basicPlusDiscount') }}
                  </div>
                </div>
                <div class="info-item" v-if="applyPlanData.isPlus === 'true'">
                  <div class="info-name">{{ $t('plan.pricing.additionalPlusPlan') }}</div>
                  <div class="info-value">
                    {{ $t('plan.pricing.applyTimes') }}
                  </div>
                </div>
                <div v-if="applyPlanData.isYearly === 'true'" class="info-item">
                  <div class="info-name">{{ $t('plan.pricing.annualDiscount') }}</div>
                  <div class="info-value">{{ $t('plan.pricing.tenPercentDiscount') }}</div>
                </div>
              </div>
            </div>
            <div class="plan-price-info">
              <div class="final-price">{{ applyPlanData.price | thousand }}{{ $t('plan.pricing.currencyUnit') }}</div>
              <div class="price-per-month">{{ $t('plan.pricing.monthlyFee') }} {{ pricePerMonth | thousand(0)  }}{{ $t('plan.pricing.currencyUnit') }} / {{ $t('common.vat') }}</div>
              <template v-if="paymentBtnType === 'contact'">
                <button class="price-payment-btn ui-btn primary size--large" @click="onContactUs" >{{ $t('plan.pricing.enterprise.contactUs') }}</button>
              </template>
              <template v-else>
                <button class="price-payment-btn ui-btn primary size--large" @click="onNextPlan(applyPlanData.planNumber, null)">{{ $t('common.confirm') }}</button>
              </template>
            </div>
          </div>
        </div>
      </dimmed>
    </div>
  </section>
</template>

<script>
import AppDialog from '@/components/ui/AppDialog'
import Dimmed from '@/components/ui/Dimmed'
import ContentBox from '@/components/ui/ContentBox'
import PlanChart from '@/components/user-info/manage-plan/PlanChart'
import RemainPvChart from '@/components/user-info/manage-plan/RemainPvChart'
import PlanSubscription from '@/components/user-info/manage-plan/PlanSubscription'
import ChargePv from '@/components/user-info/manage-plan/ChargePv'
import ChangePlan from '@/components/user-info/manage-plan/ChangePlan'
import PlanSteps from '@/components/user-info/manage-plan/PlanSteps.vue'
import ConfirmMyPage from '@/components/user-info/manage-plan/ConfirmMyPage'
import CancelSubscription from '@/components/user-info/manage-plan/CancelSubscription'
import PlanStatusDialog from '@/components/user-info/manage-plan/PlanStatusDialog'
import ConfirmCouponUser from '@/components/user-info/manage-plan/ConfirmCouponUser'
import BackToTop from '@/components/ui/BackToTop'
import UiButton from '@/components/ui/UiButton'
import BatteryIndicator from '@/components/header/BatteryIndicator'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'
import RegisterCard from '@/components/user-info/manage-plan/RegisterCard'
import { openPricing, getLocaleDateStr, tzOffsetDate, openContactUs, thousand } from '@/libs/utils'
import { PLAN_NUMBER, getNormalPlanData } from '@/libs/plan-helper'
import { create } from 'vue-modal-dialogs'
import { format } from 'date-fns'
import { mapState, mapGetters, mapActions } from 'vuex'
import { getCardInfo } from '@/api/card'
import { createPlan, updatePlan, cancelChange, purchaseCredit, getCurrentNext } from '@/api/userPlan'
import { EventBus } from '@/libs/event-bus'
import browser from '@/libs/browser'
import UiTooltip from '../../../components/ui/UiTooltip'

const openDialog = create(AppDialog)

export default {
  components: {
    UiTooltip,
    Dimmed,
    ContentBox,
    BackToTop,
    UiButton,
    BatteryIndicator,
    PlanChart,
    RemainPvChart,
    PlanSubscription,
    ChargePv,
    ChangePlan,
    PlanSteps,
    ConfirmMyPage,
    UiLoadingCircle,
    RegisterCard,
    CancelSubscription,
    PlanStatusDialog,
    ConfirmCouponUser
  },
  data () {
    return {
      isLoading: true,
      isShowPlanSubscription: false,
      isShowChangePlan: false,
      isShowCancelSubscription: false,
      isShowConfirmCouponUser: false,
      downgradeMore: null,
      newPlanData: null,
      confirmContentType: null,
      registerData: null,
      dialogData: null,
      pvHistory: null,
      isCardRegistering: false,
      chargingPv: null,
      currentChart: 'plan',
      paymentType: 'card',
      browser: browser,
      planType: null,
      isPayments: false,
      selectPlan: null,
      applyPlanData: {},
      stateApplyPlan: false,
      currentPlanData: null
    }
  },
  computed: {
    ...mapState([
      'userData',
      'planData',
      'showStickyData'
    ]),
    ...mapGetters([
      'creditData'
    ]),
    computedPlanEndDate () {
      return tzOffsetDate(this.planData.endDate, this.userData.timezone)
    },
    pvPercentage () {
      return this.creditData.percentage
    },
    useDimmed () {
      return this.isShowPlanSubscription || (this.newPlanData && this.newPlanData.planNumber > 0) || this.chargingPv ||
        this.isShowCancelSubscription || this.isShowConfirmCouponUser
    },
    canChargePv () {
      if (this.planData.isTerminated || this.planData.isTrial ||
        this.planData.isTrialOver || this.planData.isUnpaid ||
        !this.planData.hasPlan || this.planData.useCoupon) {
        return false
      } else {
        return true
      }
    },
    paymentBtnType () {
      let applyType = 'contact'
      if (!this.currentPlanData) return applyType
      if (this.currentPlanData.applyType !== 'admin' && !this.currentPlanData.bFree && this.currentPlanData.planGroup === 'PAID') {
        applyType = 'apply'
      }
      if (this.currentPlanData.planName === 'Terminate' || this.currentPlanData.planName === 'TrialOver') {
        applyType = 'apply'
      }
      if (this.applyPlanData.isYearly === 'true' || this.applyPlanData.paymentType === 'bank') {
        applyType = 'contact'
      }
      return applyType
    },
    pricePerMonth () {
      return this.applyPlanData.isYearly === 'true' ? this.applyPlanData.price / 12 : this.applyPlanData.price
    }
  },
  created () {
    this.PLAN_NUMBER = PLAN_NUMBER
    this.getLocaleDateStr = getLocaleDateStr
    this.setPlanInfo().then(() => {
      const action = this.$route.params.action

      if (action) {
        this.handlePlanAction(action)
      }
    })

    getCurrentNext().then(res => {
      this.currentPlanData = res.currentPlan
    })

    EventBus.$on('onActionTrigger', (triggeredAction) => {
      if (triggeredAction) {
        this.handlePlanAction(triggeredAction)
      }
    })
  },
  mounted () {
    if (this.$route.query.planType) {
      this.applyPlanData = this.$route.query
      this.stateApplyPlan = true
    } else {
      this.stateApplyPlan = false
    }
  },
  beforeRouteUpdate (to, from, next) {
    const action = to.params.action

    if (action) {
      this.handlePlanAction(action)
    }
    next()
  },
  methods: {
    ...mapActions([
      'storeUserData',
      'storePlanData'
    ]),
    openContactUs () {
      let form = this.$t('plan.contactForm')
      openContactUs(this.userData.userNum, form, this.planData.applyType === 'admin')
    },
    setPlanInfo () {
      this.isLoading = true
      return this.storePlanData().then(data => {
        return this.storeUserData()
      }).then(() => {
        this.isLoading = false
      }).catch(error => {
        console.error(error)
        this.isLoading = false
      })
    },
    onSelectChartType (value) {
      this.currentChart = value
    },
    onChangePlan (value) {
      if (this.planData.isWireTransferPlan) {
        return
      }

      if (this.planData.useCoupon) {
        this.isShowConfirmCouponUser = true
      } else {
        this.isShowPlanSubscription = true
      }

      if (value) {
        this.isShowPlanSubscription = true
      }
    },
    onViewMorePlans () {
      openPricing()
    },
    onCancelSubscription (reason) {
      // todo: i18n test
      updatePlan(PLAN_NUMBER.terminated, reason).then(data => {
        if (data.planUpdateError || !data.planUpdated) {
          openDialog({
            dialogType: 'plan.cancelSubscriptionFailed'
          })
          return
        }
        const changeDate = format(this.planData.endDate, 'YYYY-MM-DD')
        let status
        let info

        if (this.planData.isUnpaid) {
          status = this.$t('dialog.plan.canceled.unpaid.status')
          info = [this.$t('dialog.plan.canceled.unpaid.info')]
        } else {
          status = this.$t('dialog.plan.canceled.subscription.status')
          info = [
            this.$t('dialog.plan.canceled.subscription.info1', { changeDate }),
            this.$t('dialog.plan.canceled.subscription.info2')
          ]
        }
        this.dialogData = {
          type: 'cancel',
          title: this.$t('dialog.plan.canceled.title'),
          status: status,
          highlight: true,
          info: info
        }
      }).catch(err => {
        if (!err.isHandled) {
          openDialog({
            dialogType: 'common.error'
          })
        }
      })
    },
    onWithdrawPlanCancellation (isDowngrade) {
      // todo: i18n test
      cancelChange().then(data => {
        this.dialogData = {
          type: 'cancel',
          title: this.$t('dialog.plan.canceled.title')
        }

        if (isDowngrade) {
          this.dialogData.status = this.$t('dialog.plan.canceled.change.downgrade.status')
          this.dialogData.info = [this.$t('dialog.plan.canceled.change.downgrade.info')]
        } else {
          this.dialogData.status = this.$t('dialog.plan.canceled.change.default.status')
          this.dialogData.highlight = true
        }
      }).catch(err => {
        if (!err.isHandled) {
          openDialog({
            dialogType: 'common.error'
          })
        }
      })
    },
    onRegisterSuccess (result) {
      this.registerData = null
      this.isCardRegistering = false
    },
    onRegisterCanceled () {
      this.registerData = null
      this.isCardRegistering = false
      this.newPlanData = null
    },
    onRegisterFailed (result) {
      this.registerData = null
      this.isCardRegistering = false
      this.newPlanData = null

      openDialog({
        dialogType: 'plan.registerCardFailed',
        ok: this.$t('common.confirm')
      })
    },
    onChargePv () {
      this.chargingPv = true
    },
    onChargePvConfirm (payload) {
      getCardInfo('beusable').then(data => {
        if (!data || !data.iamportCustomerUid) {
          this.registerData = {
            customerUid: null
          }
        } else {
          this.isCardRegistering = false
          purchaseCredit({
            pvCount: payload.pv,
            totalPrice: payload.price
          }).then(data => {
            openDialog({
              dialogType: 'plan.pvCompleted',
              ok: this.$t('common.confirm')
            }).then(() => {
              this.chargingPv = null
              this.setPlanInfo()
            })
          }).catch(err => {
            this.chargingPv = null
            if (!err.isHandled) {
              let errorMessage = 'plan.registerCardFailed'
              switch (err.message) {
                case 'No Current Plan found':
                  errorMessage = 'plan.noCurrentPlanFound'
              }
              openDialog({
                dialogType: errorMessage
              })
            }
          })
        }
      }).catch(err => {
        if (!err.isHandled) {
          openDialog({
            dialogType: 'common.error'
          })
        }
        this.chargingPv = null
      })
    },
    onPlanNumberChange (paymentType, planNumber, planType) {
      this.newPlanData = getNormalPlanData(planNumber)
      this.planType = planType
      this.isCardRegistering = true
      this.paymentType = paymentType
      getCardInfo('beusable').then(data => {
        if (!data || !data.iamportCustomerUid) {
          this.registerData = {
            customerUid: null
          }
        } else {
          this.isCardRegistering = false
        }
        this.isShowPlanSubscription = false
      }).catch(err => {
        if (!err.isHandled) {
          openDialog({
            dialogType: 'common.error'
          })
        }
      })
    },
    onNextPlan (planNumber, planType = null) {
      if (this.$route.query.planType) {
        this.newPlanData = getNormalPlanData(planNumber)
        this.isPayments = true
        this.stateApplyPlan = false
      } else {
        this.newPlanData = getNormalPlanData(planNumber)
        this.planType = planType
        this.isShowPlanSubscription = false
        this.isCardRegistering = false
      }
    },
    onPlanChangeConfirm (payload) {
      const newPlanNumber = payload.newPlanNumber
      const isDowngrade = payload.onPlanChangeConfirm

      this.newPlanData = null

      if (this.planData.canChange) {
        this.onUpdatePlan(newPlanNumber, isDowngrade)
      } else {
        this.onCreatePlan(newPlanNumber)
      }
    },
    onCreatePlan (newPlanNumber) {
      createPlan(newPlanNumber).then(data => {
        openDialog({
          dialogType: 'plan.completed',
          ok: this.$t('common.confirm')
        }).then(() => {
          this.setPlanInfo()
        })
      }).catch(err => {
        if (!err.isHandled) {
          let errorMessage = 'plan.registerCardFailed'
          switch (err.message) {
            case 'No Current Plan found':
              errorMessage = 'plan.noCurrentPlanFound'
          }
          openDialog({
            dialogType: errorMessage
          })
        }
      })
    },
    onUpdatePlan (newPlanNumber, isDowngrade) {
      updatePlan(newPlanNumber).then(data => {
        if (data.planUpdateError || !data.planUpdated) {
          openDialog({
            dialogType: 'plan.updateFailed'
          })
          return
        }

        const dialogType = isDowngrade ? 'plan.applicationCompleted' : 'plan.completed'
        openDialog({
          dialogType,
          ok: this.$t('common.confirm')
        }).then(() => {
          this.setPlanInfo()
        })
      }).catch(err => {
        if (!err.isHandled) {
          openDialog({
            dialogType: 'common.error'
          })
        }
      })
    },
    onPlanStatusDialogConfirm (type) {
      let reload = false

      switch (type) {
        case 'cancel':
          reload = true
          break
      }

      if (reload) {
        this.setPlanInfo()
      }
      this.dialogData = null
    },
    handlePlanAction (action) {
      if (action !== 'chargePv' && this.planData.isWireTransferPlan) {
        return
      }

      switch (action) {
        case 'cancelPlanChange':
          this.onWithdrawPlanCancellation(true)
          break
        case 'withdrawPlanCancellation':
          this.onWithdrawPlanCancellation(false)
          break
        case 'cancelPlan':
          this.isShowCancelSubscription = true
          break
        case 'createPlan':
        case 'changePlan':
          this.onChangePlan()
          break
        case 'chargePv':
          this.onChargePv()
          break
      }
    },
    onPayments (value, item = null) {
      this.isPayments = value
      this.selectPlan = item
      this.newPlanData = getNormalPlanData()
      this.stateApplyPlan = false
    },
    onContactUs () {
      const planContants = this.applyPlanData
      openContactUs(this.userData.userNum,
        this.$t('userInfo.managePlan.default.wireForm', {
          product: planContants.planName,
          payments: planContants.paymentType === 'card' ? this.$t('userInfo.managePlan.changePlan.option.type3.main') : this.$t('userInfo.managePlan.changePlan.option.type3.main2'),
          isPlusPlan: planContants.isPlus === 'true' ? this.$t('userInfo.managePlan.default.answer.yes') : this.$t('userInfo.managePlan.default.answer.no'),
          period: planContants.isYearly === 'true' ? this.$t('userInfo.managePlan.changePlan.option.type2.main') : this.$t('userInfo.managePlan.changePlan.option.type2.main2'),
          amount: 1,
          pv: planContants.pv,
          price: thousand(planContants.price)
        }), true, this.$i18n.locale)
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
  .box-layout {
    position: relative;
    float: left;
    width: calc(100% - 211px);
    margin-top: 33px;
    .manage-plan__content {
      .content__header {
        @include flexXbetween;
        align-items: center;
        margin-left: 30px;
        margin-right: 30px;
        padding-bottom: 16px;

        h2 {
          font-size: 26px;
          font-weight: bold;
          color: #444444;
          padding-left: 10px;

          span {
            margin-left: 20px;
            font-size: 13px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            color: #767676;
          }
        }

        .button--wrap {
          height: 38px;

          .btn__change {
            margin-right: 5px;
          }
        }
      }
      .loading.circle {
        padding-top: 70vh;
      }
      .content__body {
        height: calc(100vh - 136px);
        padding: 1px 30px 0;
        overflow-y: auto;

        .content--wrap {
          padding: 25px;
          box-sizing: border-box;

          .content__title {
            font-size: 15px;
            font-weight: bold;
            color: #2f2f2f;
            display: inline-block;
            line-height: 21px;
            position: relative;
            vertical-align: top;
            top: -2px;

            .coupon-text {
              margin-left: 9px;
              display: inline-block;
              vertical-align: top;
              text-align: center;
              padding: 0 4px;
              height: 21px;
              box-sizing: border-box;
              line-height: 21px;
              font-size: 12px;
              font-weight: bold;
              color: $brandColor;
              border: solid 1px #ec0047;
              border-radius: 5px;
              position: relative;
              top: -1px;
            }
          }
        }

        .content__top {
          @include flexXbetween;

          .content__plan-in-use {
            margin-right: 15px;
            box-sizing: border-box;

            .content_outer {
              display: flex;
              height: 76px;
              padding: 0 25px;
              justify-content: left;
              align-items: center;
            }

            .content {
              @include flexXcenter;
              align-items: center;

              .label {
                font-size: 14px;
                font-weight: bold;
                line-height: 1;
                color: #767676;
              }
              .value {
                font-size: 14px;
                line-height: 1;
                color: #444;
              }
            }
            .content__plan-name {
              padding: 20px 25px 0 25px;
            }

            .plan-name {
              display: block;
              width: 100%;
              height: 58px;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-weight: bold;
              line-height: 58px;
              font-size: 30px;
              color: #767676;
              box-sizing: border-box;
              overflow: visible;

              &.using {
                font-size: 40px;
                color: $brandColor;
              }

              .payment-type {
                position: relative;
                margin-left: 15px;

                .icon {
                  vertical-align: middle;
                  transform: translateY(-2px);
                }

                .bubble {
                  @include positionXcenter;
                  bottom: 55px;
                  height: 54px;
                  line-height: 1px;
                  padding: 16px 20px;
                  display: none;
                }

                &:hover {
                  .bubble {
                    display: block;
                  }
                }
              }
            }
            .plan-period {
              position: relative;
              .value {
                margin-top: 10px;
                white-space: nowrap;
              }
            }
            .subscribe--wrap {
              position: relative;
              padding-left: 25px;
              margin-left: 25px;
              &:before {
                display: inline-block;
                content: '';
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
                width: 1px;
                height: 24px;
                border-left: 1px solid #d7d7d7;
              }
              .value {
                margin-top: 10px;
              }
              .start-subscribe {
                button {
                  margin-top: 10px;
                  font-size: 14px;
                  color: #ec0047;
                  .icon {
                    vertical-align: middle;
                  }
                }
              }
            }
          }
          .content__monthly-pv {
            margin-left: 15px;
            box-sizing: border-box;

            .content {
              text-align: center;
              .battery--wrap {
                @include flexYcenter;
                justify-content: center;
                margin-top: 5px;

                /deep/ .battery_wrap_menu {
                  .battery {
                    &:hover:after {
                      display: none;
                    }
                  }
                  .battery-filling {
                    display: inline-block;
                    position: absolute;
                    top: 22px;
                    left: 9px;
                    height: 16px;
                  }
                  .icon--battery {
                    width: 60px;
                    height: 60px;
                    background-size: contain;
                  }
                }

                .value__pv {
                  font-size: 20px;
                  font-weight: bold;
                  color: #666666;
                  margin-left: 10px;
                }
              }
              .remain-pv {
                margin-top: 5px;
                font-size: 18px;
                color: #767676;
                strong {
                  font-weight: bold;
                  color: $brandColor;
                }
              }
              .plan-period {
                margin-top: 10px;
                font-size: 14px;
                line-height: 1.36;
                color: #444444;
              }
              .button--wrap {
                margin-top: 15px;
              }
            }
          }
        }
      }
    }

    .content__middle {
      .chart-type {
        margin-top: 32px;
        margin-bottom: -17px;

        button {
          padding: 7px 3px;
          font-weight: bold;
          font-size: 15px;
          margin: 0 15px;
          color: #999999;

          &.on {
            color: #2f2f2f;
            border-bottom: 3px solid #ec0147;
          }

          &:first-child {
            margin-left: 10px;
          }
        }
      }
    }

    .user-applied-plan {
      background: #ffffff;
      color: #2F2F2F;
      border-radius: 14px;
      padding: 30px;
      min-width: 580px;
      box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.16), 0px 0px 0px 1px rgba(0, 0, 0, 0.16);
      .plan-title {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
        margin-bottom: 30px;
      }
      .plan-info-wrap {
        .plan-name {
          font-family: Roboto;
          font-size: 34px;
          font-style: normal;
          font-weight: 600;
          line-height: 34px;
          margin-bottom: 14px;
        }
        .plan-pv-info {
          color: #444;
          font-size: 18px;
          font-weight: 600;
          line-height: 18px;
          margin-bottom: 30px;
        }
      }
      .plan-detail-wrap {
        display: flex;
        .plan-discount-info {
          width: 50%;
          .info-list {
            display: flex;
            height: 100%;
            flex-direction: column;
            justify-content: flex-end;
            gap: 10px;
            .info-item {
              position: relative;
              display: flex;
              justify-content: space-between;
              color: #444;
              font-size: 13px;
              font-weight: 500;
              line-height: 15px;
              &:before {
                content: '';
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: 0;
                z-index: -1;
                width: 99%;
                height: 1px;
                background-image: linear-gradient(to right,transparent 50%, #979796 50%);
                background-size: 5px 1px;
              }
              &> div {
                background-color: #fff;
              }
            }
          }
        }
        .plan-price-info {
          flex-grow: 1;
          text-align: right;
          .final-price {
            text-align: right;
            font-family: Roboto;
            font-size: 30px;
            font-weight: 600;
            line-height: 35px;
            margin-bottom: 10px;
          }
          .price-per-month {
            color: #444;
            font-size: 13px;
            font-weight: 500;
            line-height: 15px;
            margin-bottom: 20px;
          }
          .price-payment-btn {
            position: relative;
            display: inline-block;
            background-color: #fff;
            border: 1px solid #bbb;
            box-sizing: border-box;
            white-space: nowrap;
            text-align: center;
            overflow: hidden;
            color: #fff;
            border: 0;
            background-color: #EC0047;
            min-width: 100px;
            height: 38px;
            border-radius: 20px;
            padding: 0 15px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            font-size: 14px;
            font-weight: 500;
            transition: background-color 0.2s ease,
            border-color 0.2s ease,
            opacity 0.1s ease,
            color 0.2s ease;
          }
        }
      }
    }
  }
</style>
